import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c6f41ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-password-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Form"], { "validation-schema": $setup.schema }, {
      default: _withCtx(({ meta }) => [
        ($setup.shouldShowUserIdInput)
          ? (_openBlock(), _createBlock($setup["TextInput"], {
              key: 0,
              class: "input-field",
              label: "아이디",
              name: "id",
              placeholder: "아이디를 입력하세요",
              value: $setup.userId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.userId) = $event))
            }, null, 8 /* PROPS */, ["value"]))
          : _createCommentVNode("v-if", true),
        _createVNode($setup["PasswordInput"], {
          class: "input-field",
          label: "현재 비밀번호",
          placeholder: "현재 비밀번호를 입력하세요",
          name: "currentPassword",
          errorMessage: $setup.errorMessage,
          value: $setup.currentPassword,
          "onUpdate:value": [
            _cache[1] || (_cache[1] = ($event: any) => (($setup.currentPassword) = $event)),
            $setup.resetErrorMessage
          ]
        }, null, 8 /* PROPS */, ["errorMessage", "value"]),
        _createVNode($setup["PasswordInput"], {
          class: "input-field",
          label: "새 비밀번호",
          placeholder: $setup.passwordField?.placeholder,
          name: "newPassword",
          value: $setup.newPassword,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.newPassword) = $event))
        }, null, 8 /* PROPS */, ["placeholder", "value"]),
        _createVNode($setup["PasswordInput"], {
          label: "새 비밀번호 확인",
          class: "input-field",
          placeholder: "비밀번호를 한번 더 입력하세요",
          name: "confirmedNewPassword",
          value: $setup.confirmedNewPassword,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($setup.confirmedNewPassword) = $event))
        }, null, 8 /* PROPS */, ["value"]),
        _createVNode($setup["BaseButton"], {
          class: "base-button",
          title: "변경",
          disabled: !meta.valid,
          onOnClick: ($event: any) => ($setup.handleClickChangePasswordBtn(meta.valid))
        }, null, 8 /* PROPS */, ["disabled", "onOnClick"]),
        ($props.isPasswordExpired && $setup.canExtendPasswordExpiration)
          ? (_openBlock(), _createBlock($setup["BaseButton"], {
              key: 1,
              class: "btn-next",
              title: "다음에 변경하기",
              onOnClick: $setup.extendPasswordExpiration
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["validation-schema"])
  ]))
}